import { render, staticRenderFns } from "./SlotTypeSelectbox.vue?vue&type=template&id=10c0d4ca"
import script from "./SlotTypeSelectbox.vue?vue&type=script&lang=js"
export * from "./SlotTypeSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports